import {Button} from 'shells/button/button';
import {ChevronRightIcon} from 'shells/icon';
import {Body} from 'shells/typography/body';

type Props = {
    title: string;
    cta?: {
        text: string;
        onClick: () => void;
    };
};

export function ExplorePageSectionHeader(props: Props) {
    return (
        <div className='flex align-center justify-sb'>
            <Body size='xlarge' color='dark' useDoyle={true} isBold={true}>
                {props.title}
            </Body>
            {props.cta && (
                <Button
                    variant='text-primary'
                    size='xlarge'
                    noPadding={true}
                    onClick={props.cta.onClick}
                >
                    <div className='flex align-center gap-8'>
                        {props.cta.text}
                        <div className='mt-2'>
                            <ChevronRightIcon size={14} wrapWithDiv={false} />
                        </div>
                    </div>
                </Button>
            )}
        </div>
    );
}
